import type { Employee } from "@/types";

const CASHIER_CORE = [
  "orders.receive",
  "orders.updateStatus",
  "pos.createOrder",
] as const;

const SHIFT_CORE = [
  "orders.receive",
  "orders.updateStatus",
  "pos.createOrder",
] as const;

const OPS_CORE = [
  "orders.receive",
  "orders.updateStatus",
  "reports.branchPerformance",
] as const;

const BRANCH_MANAGER_CORE = [
  "orders.receive",
  "orders.updateStatus",
  "pos.createOrder",
  "branch.hours",
  "branch.pickupPolicy",
  "branch.emergency",
  "reports.branchPerformance",
] as const;

const GENERAL_CORE = [
  "orders.receive",
  "orders.updateStatus",
  "branch.hours",
  "branch.pickupPolicy",
  "branch.emergency",
  "reports.branchPerformance",
] as const;

export const employees: Employee[] = [
  {
    id: "emp1",
    name: "سعد الحربي",
    phone: "0551112233",
    branchId: "b1",
    role: "branchManager",
    status: "active",
    permissions: [
      ...BRANCH_MANAGER_CORE,
      "products.availability",
      "customers.rate",
    ],
    createdAt: "١٢ مارس ٢٠٢٤",
    lastLogin: "اليوم ٢:٣٠ م",
  },
  {
    id: "emp2",
    name: "نورة القحطاني",
    phone: "0552223344",
    branchId: "b2",
    role: "generalSupervisor",
    status: "active",
    permissions: [...GENERAL_CORE, "products.stock"],
    createdAt: "٥ أبريل ٢٠٢٤",
    lastLogin: "اليوم ١١:١٠ ص",
  },
  {
    id: "emp3",
    name: "فهد الدوسري",
    phone: "0553334455",
    branchId: "b3",
    role: "operationsOfficer",
    status: "active",
    permissions: [...OPS_CORE, "products.availability"],
    createdAt: "٢٠ مايو ٢٠٢٤",
    lastLogin: "أمس ٨:٤٥ م",
  },
  {
    id: "emp4",
    name: "ريم العتيبي",
    phone: "0554445566",
    branchId: "b2",
    role: "branchManager",
    status: "active",
    permissions: [...BRANCH_MANAGER_CORE, "products.availability"],
    createdAt: "١٨ يونيو ٢٠٢٤",
    lastLogin: "اليوم ١٢:٥٥ م",
  },
  {
    id: "emp5",
    name: "خالد الشهري",
    phone: "0555556677",
    branchId: "b2",
    role: "cashier",
    status: "active",
    permissions: [...CASHIER_CORE],
    createdAt: "٢ يوليو ٢٠٢٤",
    lastLogin: "أمس ١٠:٢٠ م",
  },
  {
    id: "emp6",
    name: "منى الغامدي",
    phone: "0556667788",
    branchId: "b1",
    role: "shiftSupervisor",
    status: "active",
    permissions: [...SHIFT_CORE, "customers.rate"],
    createdAt: "٩ أغسطس ٢٠٢٤",
    lastLogin: "اليوم ٩:١٥ ص",
  },
  {
    id: "emp7",
    name: "أحمد الزهراني",
    phone: "0557778899",
    branchId: "b3",
    role: "cashier",
    status: "suspended",
    permissions: [...CASHIER_CORE],
    createdAt: "١٤ سبتمبر ٢٠٢٤",
    lastLogin: "قبل ٦ أيام",
  },
  {
    id: "emp8",
    name: "سارة العمري",
    phone: "0558889900",
    branchId: "b3",
    role: "branchManager",
    status: "active",
    permissions: [...BRANCH_MANAGER_CORE, "products.stock"],
    createdAt: "١ أكتوبر ٢٠٢٤",
    lastLogin: "قبل ٣ أيام",
  },
];